import React, { useContext, useState } from 'react'
import { Formik, Form } from "formik";
import Typography from '@mui/material/Typography';
// import { makeStyles } from "@material-ui/core/styles";
import * as Yup from 'yup';
import InputLabel from '@mui/material/InputLabel';
import Container from '@mui/material/Container';
import { Box } from '@mui/system';
import Grid from '@mui/material/Grid';
import AddUserTextfieldWrapper from "./TextField";
import SubmitButtonWrapper from "./SubmitBtn";
import SelectWrapper from "./Select";
import Role from './Role.json';
import { ContextUser } from '../Context/UserContext';
import Alert from '@mui/material/Alert';
import Snackbar from "@mui/material/Snackbar";
import IdleTimeOut from '../Session/IdleTimeOut';


function AddUser() {

  // const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  // const classes = useStyles();

  const value = useContext(ContextUser);

  // console.log("alert color",value.alert);
  // console.log("alert status",value.status);

  const initialFormState = {
    name: "",
    email: "",
    password: "",
    role: ""

  };

  const formValidation = Yup.object().shape({

    name: Yup.string()
      .max(40, '*Must be 40 characters or less')
      .required('*Required'),

    // phone: Yup.string().required('*Required')
    // .matches(phoneRegExp, '*Phone number is not valid'),

    email: Yup.string().email('Invalid email address !!').required('*Required'),

    role: Yup.string()
      .ensure()
      .required("Role is required !!"),

    password: Yup.string()
      .min(8, '*Minimum 8 characters')
      .max(30, '*Must be 30 characters or less')
      .required('*Required'),

  })


  // const [open, setOpen] = React.useState(false);


  // const handleClick = () => {
  //   setOpen(true);
  // };

  // const handleClose = (event, reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpen(false);
  // };


  const AlertComponent = React.forwardRef((props, ref) =>
    <Alert elevation={6} severity={(value.alert === 'error') ? 'error' : 'success'} variant="filled" {...props} ref={ref} />

  );


  return (

    <React.Fragment>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{

          backgroundColor: 'primary.dark',
          '&:hover': {
            backgroundColor: 'primary.main',
            opacity: [0.9, 0.8, 0.7],
          },
        }}
      >

        <Typography variant="h4" component="h2" >
          Add A User Account
        </Typography>

      </Box>
      <Container maxWidth="md" style={{ 'backgroundColor': '#efeff6' }} sx={{ mt: 10, boxShadow: 3 }} >


        <Box
          componenet="form"
          alignItems="center"
          justifyContent="center"
          sx={{
            backgroundColor: 'primary.dark',
            '&:hover': {
              backgroundColor: 'primary.main',
              opacity: [0.9, 0.8, 0.7],
            },
          }}
          m={5} pt={3}
        >

          <Formik
            initialValues={{ ...initialFormState }}
            validationSchema={formValidation}
            validateOnMount
            enableReinitialize={true}

            onSubmit={(values, { resetForm }) => {
              console.log(values);
              value.register();
              // handleClick();
              resetForm({ values: '' });


              // const userInfo = ([
              //   values.name ,
              //    values.email,
              //    values.password,
              //    values.role
              // ]);

              // console.log("userInfo",userInfo);

              // console.log("dadada" ,values.name)

              //     Axios.post("https://localhost:44340/AddFund/Add",
              //   {
              //     name : values.name,
              //     email : values.email,
              //     phone : values.phone,
              //     payment : values.payment,
              //     donation : values.donation,
              //     amount : values.amount,
              //   }
              //   )
              //   .then((response) => {
              //     console.log(response);
              //     console.log("Name :" , values.name);
              //   })


            }}



          >

            <Form >


              <IdleTimeOut />

              {/* onSubmit={formik.handleSubmit} */}
              <Grid container rowSpacing={7} columnSpacing={{ xs: 1, sm: 5, md: 20, lg: 20 }} alignContent="center" justifyContent="center" sx={{ flexDirection: { xs: "column", md: "row" } }}

              >


                <Grid item xs={10} md={7} lg={7} >
                  <InputLabel id="demo-simple-select-standard-label">Full Name</InputLabel>
                  <div>

                    <AddUserTextfieldWrapper
                      name="name"
                      label="Name"
                      placeholder="Your Name"
                      inputRef={value.Name}
                    />



                  </div>

                </Grid>




                <Grid item xs={10} md={7} lg={7} >


                  <div>

                    <InputLabel id="demo-simple-select-standard-label">Email</InputLabel>
                    <AddUserTextfieldWrapper
                      label="email"
                      name="email"
                      placeholder="Your Email"
                      inputRef={value.Email}
                    />



                  </div>
                </Grid>




                <Grid item xs={10} md={7} lg={7}>

                  <div>

                    <InputLabel id="demo-simple-select-standard-label">Password</InputLabel>
                    <AddUserTextfieldWrapper
                      label="Password"
                      name="password"
                      type='password'
                      placeholder="Enter Strong Password"
                      inputRef={value.Password}
                    />


                  </div>

                </Grid>



                <Grid item xs={10} md={7} lg={7}>


                  <div >

                    <InputLabel id="demo-simple-select-standard-label">Role</InputLabel>


                    <SelectWrapper

                      name="role"
                      label="Role"
                      options={Role}
                      inputRef={value.Role}



                    />





                  </div>
                </Grid>

                <Grid item xs={10} md={7} lg={7}>


                  <div >
                    <SubmitButtonWrapper
                    // onClick={postData}
                    >
                      submit
                    </SubmitButtonWrapper>
                  </div>

                </Grid>


              </Grid>





            </Form>
          </Formik>



        </Box>

        <Snackbar open={value.open} autoHideDuration={3000}
          onClose={value.handleClose}
          // sx={{marginLeft:33}}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
          }}
        >

          <AlertComponent onClose={value.handleClose}
          >
            {value.status}
          </AlertComponent>


        </Snackbar>


      </Container>
    </React.Fragment>

  );
}

export default AddUser;